/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/processor/types";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";

interface Props {
  processorData?: Data[];
}

interface RowData {
  id: string;
  name: string;
}

const mapDataToTable = (processors: Data[]): RowData[] => {
  return processors.map((data) => {
    return {
      id: data.id,
      name: data.attributes.Name,
    };
  });
};

export default function ProcessorTable({ processorData }: Props) {
  const history = useHistory();
  const data = mapDataToTable(processorData);

  const viewAction = (rowData: RowData) => {
    history.push(`/processor/view/${rowData.id}`);
  };

  const editAction = (rowData: RowData) => {
    history.push(`/processor/edit/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showGlobalFilter: true,
        showColumnFilters: false,
        density: "spacious",
      }}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Processor"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
